import React from "react"
import style from "./BarListItem.module.scss"
import { Bar } from "../data/bars"
import { Link } from "react-router-dom"
import { getAverageStar } from "../service/barMethods"
import { Stars } from "./Stars"

interface Props {
  bar: Bar
  image: string
  showStars?: boolean
}

const barLinkClickEvent = () => {
  // @ts-ignore
  ym(92771670, "reachGoal", "barLinkClick")
}

export const BarListItemComponent: React.FC<Props> = (props) => {
  const { bar, image, showStars } = props

  const averageStars = getAverageStar(bar)

  return (
    <div className={style.listItem}>
      <div>
        <img src={`/images/${image}.png`} alt="" />
      </div>
      <div>
        {bar.info && (
          <Link to={`/bars/${bar.id}`} onClick={barLinkClickEvent}>
            <h3>{bar.title}</h3>
          </Link>
        )}
        {!bar.info && <h3>{bar.title}</h3>}
        <p>{bar.address}</p>
        <p>{showStars && <Stars starsCount={averageStars} />}</p>
      </div>
    </div>
  )
}
